import { algoliaBlogPostsAdapter, blogPostAdapter } from 'adapters/blog'
import ArticlesResults from 'components/shared/ArticlesResults'
import BlogNav from 'components/shared/BlogNav'
import SliceManager from 'components/shared/SliceManager'
import delve from 'dlv'
import React from 'react'
import { fetchArticlesGridPage, getDataDependencies } from 'services/api'

import fetchSingleType from 'src/lib/Strapi/fetchSingleType'
import fetchContentType from 'src/lib/Strapi/fetchContentType'
import spreadStrapiData from 'src/lib/Strapi/spreadStrapiData'

import { SINGLES } from 'src/services/constants'

const Blog = ({ pageData, articlesData }) => {
  const slices = delve(pageData, 'slices')

  
  return (
    <div>
      <BlogNav
        categories={delve(pageData, 'blogPostNavCategories')}
        current={SINGLES.blog.url}
        newsletter={delve(pageData, 'newsletter')}
      />
      <ArticlesResults
        key="blog"
        pathname="/blog"
        index="blog_posts"
        adapter={algoliaBlogPostsAdapter}
        initialData={articlesData}
        withFeatured
      />
      {slices && <SliceManager slices={slices} />}
    </div>
  )
}

export async function getServerSideProps({ query, res }) {
  const { articlesData, statusCode, pageData } = await fetchArticlesGridPage({
    query,
    apiPath: '/blog',
    index: 'blog_posts',
  })
  const extendedData = await getDataDependencies(pageData[0])
  res.statusCode = statusCode

  const featured = delve(extendedData, 'featuredBlogPost.blogPost')

  if (featured && featured.id) {
    const featuredData = await fetchContentType(
      `blog-posts/${featured.id}`,
      'sort[0]=publishedAt:desc'
    )
    extendedData.featured = blogPostAdapter(featuredData)
  }

  const blogPostNav = await fetchSingleType(
    'blog-post-nav?populate=post_categories.post_sub_categories'
  )
  const blogPostNavCategories = spreadStrapiData(blogPostNav?.post_categories)
  return {
    props: {
      pageData: {
        ...extendedData,
        newsletter: delve(blogPostNav, 'newsletter') || null,
        blogPostNavCategories,
      },
      articlesData: articlesData || null,
      statusCode,
    },
  }
}

export default Blog
